module.exports = __webpack_public_path__ + "img/skate-quiz-bg.784fd544.jpg";